import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=4b4d5818"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports